import { Link } from "react-router-dom";
import appLabel from "./appLabel";

export default {
  //BREADCRUMB
  sampleItems: [{ title: appLabel.moduleSample }],

  // CASA Product
  casaProductItems: [{ title: appLabel.CASAProducts }],
  viewCasaProductItems: [
    { title: <Link to="/prd0100">{appLabel.CASAProducts}</Link> },
    { title: appLabel.CASADetailView },
  ],
  newCasaProductItems: [
    { title: <Link to="/prd0100">{appLabel.CASAProducts}</Link> },
    { title: appLabel.AddCASAProducts },
  ],
  editCasaProductItems: [
    { title: <Link to="/prd0100">{appLabel.CASAProducts}</Link> },
    { title: appLabel.EditCASAProducts },
  ],

  // RECURRING DEPOSIT PRODUCT
  recurringDepositProductItems: [{ title: appLabel.RecurringDepositProduct }],
  viewRecurringDepositProductItems: [
    { title: <Link to="/prd0400">{appLabel.RecurringDepositProducts}</Link> },
    { title: appLabel.RecurringDepositProductDetailView },
  ],
  newRecurringDepositProductItems: [
    { title: <Link to="/prd0400">{appLabel.RecurringDepositProducts}</Link> },
    { title: appLabel.AddRecurringDepositProduct },
  ],
  editRecurringDepositProductItems: [
    { title: <Link to="/prd0400">{appLabel.RecurringDepositProducts}</Link> },
    { title: appLabel.EditRecurringDepositProduct },
  ],

  // FINANCE RULE
  financeRuleItems: [{ title: appLabel.financeRules }],
  // NEW FINANCE RULE
  newFinanceRuleItems: [
    { title: <Link to="/gla0300">{appLabel.financeRules}</Link> },
    { title: appLabel.newFinanceRules },
  ],
  // VIEW FINANCE RULE
  viewFinanceRuleItems: [
    { title: <Link to="/gla0300">{appLabel.financeRules}</Link> },
    { title: appLabel.viewFinanceRuleDetail },
  ],
  // EDIT FINANCE RULE
  editFinanceRuleItems: [
    { title: <Link to="/gla0300">{appLabel.financeRules}</Link> },
    { title: appLabel.editFinanceRules },
  ],

  manageCustomerItems: [{ title: appLabel.manageCustomer }],
  manageGeneralLedgerItems: [{ title: appLabel.generalLedger }],
  detailGLItems: [
    { title: <Link to="/gla0100">{appLabel.generalLedger}</Link> },
    { title: appLabel.glDetailView },
  ],
  editGLItems: [
    { title: <Link to="/gla0100">{appLabel.generalLedger}</Link> },
    { title: appLabel.editGLAccount },
  ],
  newGLItems: [
    { title: <Link to="/gla0100">{appLabel.generalLedger}</Link> },
    { title: appLabel.newGLAccount },
  ],

  // STAND ALONE DATA
  listStatusData: [
    { key: 1, value: "active", label: "Active" },
    // { key: 2, value: "unauthorised", label: "Unauthorised" },
    { key: 3, value: "disabled", label: "Disabled" },
  ],

  statusData: [
    { value: "A", label: "Active" },
    { value: "D", label: "Disabled" },
    { value: "C", label: "Closed" },
  ],
  // JOURNAL ENTRY
  journalEntryItems: [{ title: appLabel.journalEntries }],
  newJournalEntryItems: [
    { title: <Link to="/gla0200">{appLabel.journalEntries}</Link> },
    { title: appLabel.newJournalEntry },
  ],
  viewJournalEntryItems: [
    { title: <Link to="/gla0200">{appLabel.journalEntries}</Link> },
    { title: appLabel.viewJournalEntryDetail },
  ],

  searchJournalEntryItems: [
    { title: <Link to="/gla0200">{appLabel.journalEntries}</Link> },
    { title: appLabel.searchJournalEntry },
  ],

  // GL MAPPING
  financialActivityLabelMapping: {
    assetTransfer: "Asset Transfer",
    liabilityTransfer: "Liability Transfer",
    cashAtMainVault: "Cash at Main Vault",
    cashAtTeller: "Cash at Teller",
    openingBalancesTransferContra: "Opening Balances Transfer Contract",
    fundSource: "Fund Source",
    payableDividends: "Payable Dividends",
  },
  GLMappingItems: [{ title: appLabel.GLMapping }],
  newGLMappingItems: [
    { title: <Link to="/gla0400">{appLabel.GLMapping}</Link> },
    { title: appLabel.newGLMapping },
  ],
  viewGLMappingItems: [
    { title: <Link to="/gla0400">{appLabel.GLMapping}</Link> },
    { title: appLabel.GLMappingDetailBreadcrumbs },
  ],
  editGLMappingItems: [
    { title: <Link to="/gla0400">{appLabel.GLMapping}</Link> },
    { title: appLabel.EditGLMappingBreadcrumbs },
  ],

  // END OF CIRCLES
  endOfCirclesItems: [{ title: appLabel.accountClosure }],
  // NEW END OF CIRCLES
  newEndOfCirclesItems: [
    { title: <Link to="/gla0800">{appLabel.accountClosure}</Link> },
    { title: appLabel.newAccountClosure },
  ],
  // VIEW END OF CIRCLES
  viewEndOfCirclesItems: [
    { title: <Link to="/gla0800">{appLabel.accountClosure}</Link> },
    { title: appLabel.viewAccountClosureDetail },
  ],

  // PERIODIC ACCRUAL
  periodicAccrualItems: [{ title: appLabel.periodicAccrual }],

  // FUND SOURCE
  FundSourceItems: [{ title: appLabel.FundSource }],
  newFundSourceItems: [
    { title: <Link to="/gla1000">{appLabel.FundSource}</Link> },
    { title: appLabel.newFundSource },
  ],
  viewFundSourceItems: [
    { title: <Link to="/gla1000">{appLabel.FundSource}</Link> },
    { title: appLabel.FundSourcedetail },
  ],
  editFundSourceItems: [
    { title: <Link to="/gla1000">{appLabel.FundSource}</Link> },
    { title: appLabel.editFundSource },
  ],

  // FREQUENT POSTING
  frequentPostingItems: [{ title: appLabel.FrequentPosting }],
  viewFrequentPostingItems: [
    { title: <Link to="/gla0600">{appLabel.FrequentPosting}</Link> },
    { title: appLabel.viewFrequentPosting },
  ],

  // LOAN PRODUCT
  LoanProductItems: [{ title: appLabel.LoanProduct }],
  NewLoanProductItems: [
    { title: <Link to="/prd0200">{appLabel.LoanProduct}</Link> },
    {
      title: appLabel.newLoanProduct,
    },
  ],
  viewLoanProductItems: [
    { title: <Link to="/prd0200">{appLabel.LoanProduct}</Link> },
    { title: appLabel.LoanProductDetail },
  ],
  editLoanProductItems: [
    { title: <Link to="/prd0200">{appLabel.LoanProduct}</Link> },
    { title: appLabel.editLoanProduct },
  ],

  // FIXED DEPOSIT
  FixedDepositItems: [{ title: appLabel.FixedDeposit }],
  NewFixedDepositItems: [
    { title: <Link to="/prd0300">{appLabel.FixedDeposit}</Link> },
    {
      title: appLabel.newFixedDeposit,
    },
  ],
  viewFixedDepositItems: [
    { title: <Link to="/prd0300">{appLabel.FixedDeposit}</Link> },
    { title: appLabel.FixedDepositDetail },
  ],
  editFixedDepositItems: [
    { title: <Link to="/prd0300">{appLabel.FixedDeposit}</Link> },
    { title: appLabel.editFixedDeposit },
  ],

  //PROVISIONING ENTRIES
  provisioningEntriesItems: [{ title: appLabel.provisioningEntries }],
  // NEW PROVISIONING ENTRIES
  newProvisioningEntriesItems: [
    { title: <Link to="/gla1100">{appLabel.provisioningEntries}</Link> },
    { title: appLabel.newProvisioningEntries },
  ],
  // VIEW PROVISIONING ENTRIES
  viewProvisioningEntriesItems: [
    { title: <Link to="/gla1100">{appLabel.provisioningEntries}</Link> },
    { title: appLabel.viewProvisioningEntriesDetail },
  ],
  // JournalEntry PROVISIONING ENTRIES
  journalProvisioningEntriesItems: [
    { title: <Link to="/gla1100">{appLabel.provisioningEntries}</Link> },
    { title: appLabel.journalEntries },
  ],
  adHocQuerySearchForLoansItem: [{ title: appLabel.advanceSearch }],
  adHocQuerySearchForLoansItemList: [
    { title: <Link to="/search-gla0900">{appLabel.advanceSearch}</Link> },
    { title: `${appLabel.advanceSearch} List` },
  ],

  // FX RATE SETUP
  FXRateSetupItems: [{ title: appLabel.fxRateSetup }],
  NewFXRateSetupItems: [
    { title: <Link to="/mfx0100">{appLabel.LoanProduct}</Link> },
    {
      title: appLabel.newFxRateSetup,
    },
  ],
  //  CASA to GL Transfers
addCASAToGlTransfer: [
    {
      title: appLabel.addCASAToGlTransfer,
    },
  ],

  //  CASA to GL Transfers
addGLToCASATransfer: [
    {
      title: appLabel.addGlToCASATransfer,
    },
  ],

  monthList: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  months: [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ],
  revaluations: [
    { value: true, label: "Automatic Revaluation" },
    { value: false, label: "Manual Revaluation" },
  ],

  screenIdData: [
    {
      menu: "Customer",
      submenu: "Customer",
      screenid: "CST0100",
    },
    {
      menu: "Customer",
      submenu: "Collateral",
      screenid: "CST0200",
    },
    {
      menu: "Customer",
      submenu: "Limit",
      screenid: "CST0300",
    },
    {
      menu: "Customer",
      submenu: "Pricing",
      screenid: "CST0400",
    },
    {
      menu: "Customer",
      submenu: "Loyalty",
      screenid: "CST0500",
    },
    {
      menu: "GL & Accounting",
      submenu: "General Ledger",
      screenid: "GLA0100",
    },
    {
      menu: "GL & Accounting",
      submenu: "Journal Entry",
      screenid: "GLA0200",
    },
    {
      menu: "GL & Accounting",
      submenu: "Financial Rules",
      screenid: "GLA0300",
    },
    {
      menu: "GL & Accounting",
      submenu: "GL Mapping",
      screenid: "GLA0400",
    },
    {
      menu: "GL & Accounting",
      submenu: "Accounting Rules",
      screenid: "GLA0500",
    },
    {
      menu: "GL & Accounting",
      submenu: "Frequent Posting",
      screenid: "GLA0600",
    },
    {
      menu: "GL & Accounting",
      submenu: "Accruals",
      screenid: "GLA0700",
    },
    {
      menu: "GL & Accounting",
      submenu: "End of Circle",
      screenid: "GLA0800",
    },
    {
      menu: "GL & Accounting",
      submenu: "Fund Mapping",
      screenid: "GLA0900",
    },
    {
      menu: "GL & Accounting",
      submenu: "Fund Source",
      screenid: "GLA1000",
    },
    {
      menu: "GL & Accounting",
      submenu: "Provisional Entities",
      screenid: "GLA1100",
    },
    {
      menu: "Products",
      submenu: "Cuurent & Savings",
      screenid: "PRD0100",
    },
    {
      menu: "Products",
      submenu: "Retail Loan",
      screenid: "PRD0200",
    },
    {
      menu: "Products",
      submenu: "Fixed Deposit",
      screenid: "PRD0300",
    },
    {
      menu: "Products",
      submenu: "Recurring Deposit",
      screenid: "PRD0400",
    },
    {
      menu: "Products",
      submenu: "BNPL",
      screenid: "PRD0500",
    },
    {
      menu: "Products",
      submenu: "Foreign Exchange - FX",
      screenid: "PRD0600",
    },
    {
      menu: "Products",
      submenu: "Money Market - MM",
      screenid: "PRD0700",
    },
    {
      menu: "Products",
      submenu: "Letter of credit - LC",
      screenid: "PRD0800",
    },
    {
      menu: "Products",
      submenu: "Manage NPL Rules",
      screenid: "PRD0900",
    },
    {
      menu: "Products",
      submenu: "Manage Fees & Charges",
      screenid: "PRD1000",
    },
    {
      menu: "Products",
      submenu: "Manage Interest Rate",
      screenid: "PRD1100",
    },
    {
      menu: "Products",
      submenu: "Manage Exchange Rate",
      screenid: "PRD1200",
    },
    {
      menu: "Products",
      submenu: "Manage Tax",
      screenid: "PRD1300",
    },
    {
      menu: "Products",
      submenu: "Manage Product Mix",
      screenid: "PRD1400",
    },
    {
      menu: "Operations",
      submenu: "Branch Operations ",
      screenid: "OPS0100",
    },
    {
      menu: "Operations",
      submenu: "Teller Services",
      screenid: "OPS0200",
    },
    {
      menu: "Operations",
      submenu: "Loan Origination",
      screenid: "OPS0300",
    },
    {
      menu: "Operations",
      submenu: "LC Initiation",
      screenid: "OPS0400",
    },
    {
      menu: "Operations",
      submenu: "Collections",
      screenid: "OPS0500",
    },
    {
      menu: "Operations",
      submenu: "Cheque",
      screenid: "OPS0600",
    },
    {
      menu: "Security Management",
      submenu: "Manage User",
      screenid: "SMS0100",
    },
    {
      menu: "Security Management",
      submenu: "Manage Password",
      screenid: "SMS0200",
    },
    {
      menu: "Security Management",
      submenu: "Manaage Role & Privilege",
      screenid: "SMS0300",
    },
    {
      menu: "Security Management",
      submenu: "Audit Trail",
      screenid: "SMS0400",
    },
    {
      menu: "Security Management",
      submenu: "Manage Authoristation",
      screenid: "SMS0500",
    },
    {
      menu: "Payments & Transfers",
      submenu: "Local Transfer",
      screenid: "PMT0100",
    },
    {
      menu: "Payments & Transfers",
      submenu: "Swift Transfer",
      screenid: "PMT0200",
    },
    {
      menu: "Payments & Transfers",
      submenu: "Wallet Transfer",
      screenid: "PMT0300",
    },
    {
      menu: "Payments & Transfers",
      submenu: "Pay Merchant",
      screenid: "PMT0400",
    },
    {
      menu: "Payments & Transfers",
      submenu: "Pay Government",
      screenid: "PMT0500",
    },
    {
      menu: "Cards & eChannel",
      submenu: "Manage Channel",
      screenid: "CAC0100",
    },
    {
      menu: "Cards & eChannel",
      submenu: "Manage ATM",
      screenid: "CAC0200",
    },
    {
      menu: "Cards & eChannel",
      submenu: "Manage POS",
      screenid: "CAC0300",
    },
    {
      menu: "Cards & eChannel",
      submenu: "Manage Card",
      screenid: "CAC0400",
    },
    {
      menu: "Reporting & Analytics",
      submenu: "Loan Report",
      screenid: "RPA0100",
    },
    {
      menu: "Reporting & Analytics",
      submenu: "Customer Report",
      screenid: "RPA0200",
    },
    {
      menu: "Reporting & Analytics",
      submenu: "Account Report",
      screenid: "RPA0300",
    },
    {
      menu: "Reporting & Analytics",
      submenu: "Security Report",
      screenid: "RPA0400",
    },
    {
      menu: "Sys Config",
      submenu: "Core Parameters",
      screenid: "SYS0100",
    },
    {
      menu: "Sys Config",
      submenu: "Manage Funds",
      screenid: "SYS0200",
    },
    {
      menu: "Sys Config",
      submenu: "Manage Holiday",
      screenid: "SYS0300",
    },
    {
      menu: "Sys Config",
      submenu: "Manage Workdays",
      screenid: "SYS0400",
    },
    {
      menu: "Sys Config",
      submenu: "Manage Codes",
      screenid: "SYS0500",
    },
    {
      menu: "Sys Config",
      submenu: "Password Settings",
      screenid: "SYS0600",
    },
    {
      menu: "Sys Config",
      submenu: "Scheduler Jobs",
      screenid: "SYS0700",
    },
    {
      menu: "Sys Config",
      submenu: "Global Settings Config",
      screenid: "SYS0800",
    },
    {
      menu: "Sys Config",
      submenu: "2FA Config",
      screenid: "SYS0900",
    },
    {
      menu: "Sys Config",
      submenu: "Account Settings",
      screenid: "SYS1000",
    },
    {
      menu: "Sys Config",
      submenu: "Manage Payment Type",
      screenid: "SYS1100",
    },
    {
      menu: "Sys Config",
      submenu: "Manage Currency",
      screenid: "SYS1200",
    },
    {
      menu: "Sys Config",
      submenu: "Manage Hooks",
      screenid: "SYS1300",
    },
    {
      menu: "Sys Config",
      submenu: "Entity Mapping",
      screenid: "SYS1400",
    },
    {
      menu: "Sys Config",
      submenu: "Manage KYC",
      screenid: "SYS1500",
    },
    {
      menu: "Utility",
      submenu: "Manage Employee",
      screenid: "UTL0100",
    },
    {
      menu: "Utility",
      submenu: "SMS Campaigns",
      screenid: "UTL0200",
    },
    {
      menu: "Utility",
      submenu: "Adhoc Query",
      screenid: "UTL0300",
    },
    {
      menu: "Utility",
      submenu: "Bulk Loan Reassignment",
      screenid: "UTL0400",
    },
    {
      menu: "Utility",
      submenu: "Bulk Import",
      screenid: "UTL0500",
    },
    {
      menu: "Utility",
      submenu: "Manage Survey",
      screenid: "UTL0600",
    },
    {
      menu: "Utility",
      submenu: "Use Define Fields",
      screenid: "UTL0700",
    },
    {
      menu: "System Admin",
      submenu: "Account Numbering",
      screenid: "SYA0100",
    },
    {
      menu: "System Admin",
      submenu: "Branch",
      screenid: "SYA0200",
    },
    {
      menu: "System Admin",
      submenu: "Branch Types",
      screenid: "SYA0300",
    },
    {
      menu: "System Admin",
      submenu: "Branch Configuration",
      screenid: "SYA0400",
    },
    {
      menu: "System Admin",
      submenu: "Branch Vault Setup",
      screenid: "SYA0500",
    },
    {
      menu: "System Admin",
      submenu: "Till Configuration",
      screenid: "SYA0600",
    },
    {
      menu: "System Admin",
      submenu: "Holiday",
      screenid: "SYA0700",
    },
    {
      menu: "System Admin",
      submenu: "Workdays",
      screenid: "SYA0800",
    },
    {
      menu: "System Admin",
      submenu: "Entity Table",
      screenid: "SYA0900",
    },
    {
      menu: "System Admin",
      submenu: "User Defined Table",
      screenid: "SYA1000",
    },
    {
      menu: "System Admin",
      submenu: "Payment Type",
      screenid: "SYA1100",
    },
    {
      menu: "System Admin",
      submenu: "Code Definition",
      screenid: "SYA1200",
    },
    {
      menu: "System Admin",
      submenu: "Currency",
      screenid: "SYA1300",
    },
    {
      menu: "System Admin",
      submenu: "SMS Campaign",
      screenid: "SYA1400",
    },
    {
      menu: "System Admin",
      submenu: "System Hook",
      screenid: "SYA1500",
    },
    {
      menu: "System Admin",
      submenu: "Bulk Import",
      screenid: "SYA1600",
    },
    {
      menu: "System Admin",
      submenu: "Entity Mapping",
      screenid: "SYA1700",
    },
    {
      menu: "System Admin",
      submenu: "Customer Survey",
      screenid: "SYA1800",
    },
    {
      menu: "System Admin",
      submenu: "Template",
      screenid: "SYA1900",
    },
    {
      menu: "System Admin",
      submenu: "External Services",
      screenid: "SYA2000",
    },
    {
      menu: "System Admin",
      submenu: "Global Configuration",
      screenid: "SYA2100",
    },
    {
      menu: "System Admin",
      submenu: "Adhoc Query Setup",
      screenid: "SYA2200",
    },
    {
      menu: "System Admin",
      submenu: "Batch Job Operations",
      screenid: "SYA2300",
    },
    {
      menu: "System Admin",
      submenu: "Bulk Loan Reassignment",
      screenid: "SYA2400",
    },
    {
      menu: "System Admin",
      submenu: "Client Category",
      screenid: "SYA2500",
    },
    {
      menu: "System Admin",
      submenu: "Limit Rule Marker",
      screenid: "SYA2600",
    },
    {
      menu: "Teller Operations",
      submenu: "Link User to Till",
      screenid: "TLO0100",
    },
    {
      menu: "Teller Operations",
      submenu: "Branch Batch",
      screenid: "TLO0200",
    },
    {
      menu: "Teller Operations",
      submenu: "Vault Branch",
      screenid: "TLO0300",
    },
    {
      menu: "Teller Operations",
      submenu: "Teller Branch",
      screenid: "TLO0400",
    },
    {
      menu: "Teller Operations",
      submenu: "Send Cash",
      screenid: "TLO0500",
    },
    {
      menu: "Teller Operations",
      submenu: "Request Cash",
      screenid: "TLO0600",
    },
    {
      menu: "Teller Operations",
      submenu: "Receive Teller Transactions",
      screenid: "TLO0700",
    },
    {
      menu: "Teller Operations",
      submenu: "Cash Deposit",
      screenid: "TLO0800",
    },
    {
      menu: "Teller Operations",
      submenu: "Cash Withdrawal",
      screenid: "TLO0900",
    },
    {
      menu: "Teller Operations",
      submenu: "Fund Transfer",
      screenid: "TLO1000",
    },
  ],

  // ACCOUNTING RULES ITEMS
  AccountingRulesItems: [{ title: appLabel.AccountingRules }],
  newAccountingRulesItems: [
    { title: <Link to="/gla0500">{appLabel.AccountingRules}</Link> },
    { title: appLabel.newAccountingRules },
  ],
  detailAccountingRulesItems: [
    { title: <Link to="/gla0500">{appLabel.AccountingRules}</Link> },
    { title: appLabel.AccountingRulesDetail },
  ],
  editAccountingRulesItems: [
    { title: <Link to="/gla0500">{appLabel.AccountingRules}</Link> },
    { title: appLabel.EditAccountingRuleBreadcrumbs },
  ],

  // STAND ALONE DATA
  tableStatusData: [
    { key: 1, value: "status", label: "All Status" },
    { key: 2, value: "active", label: "Active" },
    { key: 3, value: "closed", label: "Closed" },
    {
      key: 4,
      value: "submitted and pending approval",
      label: "Pending Approval",
    },
  ],
  loanStatusData: [
    { key: 1, value: "status", label: "All Status" },
    { key: 2, value: "active", label: "Active" },
    { key: 3, value: "inActive", label: "Inactive" },
  ],
};
